require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-stuart-hunter.json") })
        }
      }, "path---interview-stuart-hunter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-stuart-hunter!./.cache/json/interview-stuart-hunter.json
// module id = 715
// module chunks = 231608221292675